export class VisibilityLayerModel {
  name: string;
  objectIds: string[];
}

export class VisibilityLayersModel {
  current: {
    index?: number;
    position?: number;
    layers?: VisibilityLayerModel[];
  };
  src: {
    initIndex?: number;
    layers?: VisibilityLayerModel[];
  };
}
